module.exports = __webpack_public_path__ + "img/zdd_invite_header_bg.74e9a861.png";